let productFinderElement = document.querySelector(
  "[data-react-component=PFSearch]",
);

let siteSearchElement = document.querySelector(
  "[data-react-component=SiteSearch]",
);

let customerSuccessStoriesElement = document.querySelector(
  "[data-react-component=CustomerSuccessStories]",
);

let type = "product-finder";
let placeholderText = " Product search... ";
if (siteSearchElement) {
  type = "site-search";
  placeholderText = "Search...";
}

let componentElement = productFinderElement || siteSearchElement || customerSuccessStoriesElement;

let resultsAreaElement = componentElement?.querySelector(
  ".product-finder-search-results-section, .site-search-results-section",
);

let filterJsonString = componentElement?.getAttribute("data-prop-filter-tags");
let filterJson = {};
if (filterJsonString) {
  filterJson = JSON.parse(filterJsonString);
}

let popularCategoriesJsonString = componentElement?.getAttribute(
  "data-prop-popular-categories",
);
let popularCategoriesJson = {};
if (popularCategoriesJsonString) {
  popularCategoriesJson = JSON.parse(popularCategoriesJsonString);
}

let popularSearchTerms =
  componentElement
    ?.getAttribute("data-prop-popular-search-terms")
    ?.split(",") || "";

let mostPopularProductsString = componentElement?.getAttribute(
  "data-prop-most-popular-products",
);
let mostPopularProductsArray = [];
if (mostPopularProductsString) {
  let mostPopularProductsJson = JSON.parse(mostPopularProductsString);
  mostPopularProductsArray = mostPopularProductsJson.map((item) => {
    return item.path.replaceAll("'", "");
  });
}

let mostPopularPagesString = componentElement?.getAttribute(
    "data-prop-most-popular-pages",
);
let mostPopularPagesArray = [];
if (mostPopularPagesString) {
  let mostPopularProductsJson = JSON.parse(mostPopularPagesString);
  mostPopularPagesArray = mostPopularProductsJson.map((item) => {
    return item.path.replaceAll("'", "");
  });
}

let emptyResults = componentElement?.getAttribute("data-prop-empty-results");
let componentPath = componentElement?.getAttribute("data-prop-component-path");

export const initialState = {
  filterJson: filterJson,
  componentElement: componentElement,
  componentType: type,
  resultsAreaElement: resultsAreaElement,
  popularCategoriesJson: popularCategoriesJson,
  mostPopularProductsArray: mostPopularProductsArray,
  mostPopularPagesArray: mostPopularPagesArray,
  popularSearchTerms: popularSearchTerms,
  searchTerm: "",
  filters: [],
  completeSearchResultSet: [],
  emptyResults: emptyResults,
  query: "",
  searchResultsFromQuery: [],
  filteredResults: [],
  selectedFilters: [],
  isReady: false,
  initialRenderRequired: true,
  currentPage: 1,
  pageCount: 1,
  searchError: false,
  searchTermHasChanged: false,
  showSuggestions: false,
  sortTypeApplied: "",
  suggestions: [],
  isLoading: false,
  showResults: false,
  filterContainerIsVisible: false,
  filterDrawerIsOpen: false,
  searchBarHasFocus: false,
  placeholderText: placeholderText,
  resultsToShow_mobile: 6,
  resultsToShowStepSize_mobile: 6,
  resultsToShow_tablet: 6,
  resultsToShowStepSize_tablet: 6,
  resultsToShow_desktop: 6,
  resultsToShowStepSize_desktop: 6,
  componentPath: componentPath,
  sortIndex: 0,
  externalQueryId: ""
};

export const searchReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_SEARCH_TERM":
      return { ...state, searchTerm: action.payload };
    case "UPDATE_FILTERS":
      return { ...state, filters: action.payload };
    case "UPDATE_READINESS":
      return { ...state, isReady: action.payload };
    case "SET_INITIAL_RENDER_REQUISITE":
      return { ...state, initialRenderRequired: action.payload };
    case "UPDATE_CURRENT_PAGE":
      return { ...state, currentPage: action.payload };
    case "UPDATE_PAGE_COUNT":
      return { ...state, pageCount: action.payload };
    case "UPDATE_SEARCH_ERROR":
      return { ...state, searchError: action.payload };
    case "UPDATE_COMPLETE_SEARCH_RESULT_SET":
      return { ...state, completeSearchResultSet: action.payload };
    case "UPDATE_SEARCH_RESULTS_FROM_QUERY":
      return { ...state, searchResultsFromQuery: action.payload };
    case "UPDATE_FILTERED_RESULTS":
      return { ...state, filteredResults: action.payload };
    case "UPDATE_SORTED_RESULTS":
      return { ...state, filteredResults: action.payload };
    case "UPDATE_SEARCH_TERM_HAS_CHANGED":
      return { ...state, searchTermHasChanged: action.payload };
    case "UPDATE_SHOW_RESULTS":
      return { ...state, showResults: action.payload };
    case "UPDATE_SHOW_SUGGESTIONS":
      return { ...state, showSuggestions: action.payload };
    case "UPDATE_SORT_TYPE_APPLIED":
      return { ...state, sortTypeApplied: action.payload };
    case "UPDATE_SUGGESTIONS":
      return { ...state, suggestions: action.payload };
    case "UPDATE_IS_LOADING":
      return { ...state, isLoading: action.payload };
    case "UPDATE_FILTER_CONTAINER_IS_VISIBLE":
      return { ...state, filterContainerIsVisible: action.payload };
    case "UPDATE_FILTER_DRAWER_IS_OPEN":
      return { ...state, filterDrawerIsOpen: action.payload };
    case "UPDATE_SEARCH_PARAM":
      return { ...state, searchParam: action.payload };
    case "UPDATE_SELECTED_FILTERS":
      return { ...state, selectedFilters: action.payload };
    case "UPDATE_SEARCH_BAR_HAS_FOCUS":
      return { ...state, searchBarHasFocus: action.payload };
    case "UPDATE_RESULTS_TO_SHOW_MOBILE":
      return { ...state, resultsToShow_mobile: action.payload };
    case "UPDATE_RESULTS_TO_SHOW_STEPSIZE_MOBILE":
      return { ...state, resultsToShowStepSize_mobile: action.payload };
    case "UPDATE_RESULTS_TO_SHOW_TABLET":
      return { ...state, resultsToShow_tablet: action.payload };
    case "UPDATE_RESULTS_TO_SHOW_STEPSIZE_TABLET":
      return { ...state, resultsToShowStepSize_tablet: action.payload };
    case "UPDATE_RESULTS_TO_SHOW_DESKTOP":
      return { ...state, resultsToShow_desktop: action.payload };
    case "UPDATE_RESULTS_TO_SHOW_STEPSIZE_DESKTOP":
      return { ...state, resultsToShowStepSize_desktop: action.payload };
    case "UPDATE_SORT_INDEX":
      return { ...state, sortIndex: action.payload };
    case "UPDATE_EXTERNEAL_QUERY_ID":
      return { ...state, externalQueryId: action.payload };
    default:
      return state;
  }
};
